<template>
  <b-modal
    id="approveRejectModal"
    :visible="openAcceptReject"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    size="md"
    @hidden="closeAcceptReject"
  >
    <div class="cs-modal-header">
      <div class="b-modal-header" style="text-transform: capitalize">
        {{ decision }} {{ from }}
      </div>
      <div>
        <img
          @click="closeAcceptReject"
          src="../../../assets/New-imgs/teams-icons/teams-close-icon.svg"
          alt=""
          class="pointer rotate-on-hover"
        />
      </div>
    </div>

    <section class="p-3">
      <div class="newJD-modal-body-text">
        Are you sure you want to {{ decision }} this {{ from }} ”{{ title }}”?
      </div>
      <div class="mt-3">
        <div class="topDiv">
          <label class="teams-label-font"
            >Remarks<span v-if="decision === 'reject'" class="asterik"
              >*</span
            ></label
          >
          <b-form-textarea
            class="teams-inputField"
            placeholder="Enter Remarks"
            rows="3"
            max-rows="7"
            v-model.trim="$v.remarks.$model"
            :class="{ error: $v.remarks.$error }"
            no-resize
          ></b-form-textarea>
          <div
            class="errortxt position-absolute"
            v-if="$v.remarks.$dirty && !$v.remarks.required"
          >
            Required
          </div>
          <div
            class="errortxt position-absolute"
            v-else-if="!$v.remarks.maxLength"
          >
            Exceeded the max char length of 256
          </div>
        </div>
        <div
          v-if="isExpired === 'true'"
          class="acceptreject-warning-text"
          :class="$v.remarks.$dirty && !$v.remarks.required ? 'mt-3' : 'mt-2'"
        >
          <img
            src="../../../assets/New-imgs/interviewProcess-icons/accept-reject-i-icon.svg"
            alt
          />
          <span class="ml-3">This job has been expired</span>
        </div>
      </div>
    </section>
    <hr class="my-0" />
    <section class="p-3">
      <div class="d-flex align-items-center justify-content-end bluebtn">
        <b-button @click="closeAcceptReject" class="acs-cancelBtn-modal mr-3"
          >Cancel</b-button
        >
        <div class="position-relative">
          <b-button
            @click="!showLoader ? acceptReject() : ''"
            :disabled="showLoader"
            class="acs-addBtn-modal"
            :class="showLoader && 'defaultCursor'"
            :style="{
              'text-transform': 'capitalize',
              color: showLoader ? 'transparent' : '',
            }"
            >{{ decision }}</b-button
          >
          <div v-if="showLoader" class="job-add-loader-pos">
            <Loader />
          </div>
        </div>
      </div>
    </section>
  </b-modal>
</template>

<script>
import {
  patchJobDesc,
  finalSelectionApproval,
} from "../../../utils/apiFunctions";
import { requiredIf, maxLength } from "vuelidate/lib/validators";
import toast from "../../../components/mixin/toast";
import Loader from "../../../components/fixedcomponents/Loader.vue";

export default {
  props: {
    openAcceptReject: Boolean,
    decision: String,
    title: String,
    from: String,
    jobID: String,
    candidateID: String,
    isExpired: String,
  },
  mixins: [toast],
  components: { Loader },
  data() {
    return { showLoader: false, remarks: "" };
  },

  validations: {
    remarks: {
      required: requiredIf(function () {
        return this.decision === "reject";
      }),
      maxLength: maxLength(256),
    },
  },

  methods: {
    async acceptReject() {
      this.showLoader = true;
      if (this.from === "job") {
        await this.acceptRejectJD();
      } else {
        await this.acceptRejectCandidate();
      }
      this.showLoader = false;
    },

    async acceptRejectJD() {
      this.$v.remarks.$touch();
      if (!this.$v.remarks.$invalid) {
        try {
          let status, successMessage;
          if (this.decision === "approve") {
            status = "3";
            successMessage = `Job ${this.title} has been approved`;
          } else {
            status = "4";
            successMessage = `Job ${this.title} has been rejected`;
          }

          let payload = {
            jobID: this.jobID,
            status: status,
            remarks: this.remarks,
          };

          const response = await patchJobDesc(payload);
          if (response.status == 200) {
            this.$v.$reset();
            this.remarks = "";
            this.successModal(successMessage);
            this.$emit("close-accept-reject");
          } else {
            this.errorModal(response.data.data.Detail);
          }
        } catch (error) {
          this.errorModal("Something went wrong");
          console.error(error);
        }
      }
    },

    async acceptRejectCandidate() {
      this.$v.remarks.$touch();
      if (!this.$v.remarks.$invalid) {
        try {
          let payload = {
            candidateID: this.candidateID,
            jobID: this.jobID,
            remarks: this.remarks,
            approved: this.decision === "approve",
          };

          const response = await finalSelectionApproval(payload);

          if (response.status === 200) {
            this.remarks = "";
            this.$v.$reset();
            const successMessage =
              this.decision === "approve"
                ? `Candidate ${this.title} has been approved`
                : `Candidate ${this.title} has been rejected`;
            this.successModal(successMessage);
            this.$emit("close-accept-reject");
            this.$router.push({
              name: "ReviewCandidates",
            });
          } else {
            this.errorModal(response.data.data.Detail);
          }
        } catch (error) {
          this.errorModal("Something went wrong");
          console.error(error);
        }
      }
    },

    closeAcceptReject() {
      this.remarks = "";
      this.$v.$reset();
      this.$emit("close-accept-reject", "cancel");
    },
  },
};
</script>

<style scoped>
.acceptreject-warning-text {
  font-family: "Montserrat", sans-serif;
  font-size: var(--size-12);
  color: var(--bluetheme);
}

.newJD-modal-body-text {
  font-family: "Lato", sans-serif;
  font-size: 16px;
  line-height: 30px;
  color: #333333;
}

.topDiv > .error {
  border: 1px solid red !important;
}

.job-add-loader-pos {
  position: absolute;
  top: 59%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* Compensate for the Loader's internal offsets (top: 35px, left: 45px) and size */
  margin-top: -35px;
  margin-left: -45px;
}
</style>
